import { render, staticRenderFns } from "./CategoriesComponent.vue?vue&type=template&id=26f67532&scoped=true"
import script from "./CategoriesComponent.vue?vue&type=script&lang=js"
export * from "./CategoriesComponent.vue?vue&type=script&lang=js"
import style0 from "./CategoriesComponent.vue?vue&type=style&index=0&id=26f67532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f67532",
  null
  
)

export default component.exports